import { css } from "@emotion/react";

const Tickets: React.FC = () => {
  return (
    <div css={mainStyle} id="ticket">
      <div css={staffContentsWrapperStyle}>
        <div css={titleWrapp}>
          <div css={upperTitleWrapperStyle}>
            <div css={borderStyle}></div>
            <div css={titleStyle}>チケット</div>
            <div css={borderStyle}></div>
          </div>
        </div>
      </div>
      <div css={ticketInfoWrapperStyle()}>
        <img
          src={
            process.env.REACT_APP_ASSET_BASE_PATH +
            "/img/ticket-official-advance.png"
          }
          alt="オフィシャル先行 (抽選)"
          css={ticketInfoImgStyle}
        />
      </div>
      <div css={ticketInfoWrapperStyle()}>
        <img
          src={
            process.env.REACT_APP_ASSET_BASE_PATH +
            "/img/ticket-lawson-advance.png"
          }
          alt="ローソンチケット先行 (抽選)"
          css={ticketInfoImgStyle}
        />
      </div>
      <div css={ticketInfoWrapperStyle()}>
        <img
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/ticket-lawson.png"}
          alt="一般発売 (ローソンチケット)"
          css={lawsonTicketInfoImgStyle}
        />
        <div css={ticketLinkStyle}>
          <a
            href="https://l-tike.com/ashigirl/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={
                process.env.REACT_APP_ASSET_BASE_PATH +
                "/img/redirect-to-ticket.png"
              }
              alt="チケット購入先"
              width="220"
            />
          </a>
        </div>
        <div css={contactStyle}>お問い合わせ：contact@808.baby</div>
        <div css={ticketInfoWrapperStyle(40)}>
          <img
            src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/canfeti-top.png"}
            css={canfetiImgStyle}
          />
          <div>
            <a
              href="https://www.confetti-web.com/ashigirl"
              css={linkTxtStyle}
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.confetti-web.com/ashigirl
            </a>
          </div>
          <img
            src={
              process.env.REACT_APP_ASSET_BASE_PATH + "/img/canfeti-bottom.png"
            }
            css={canfetiImgStyle}
          />
        </div>
        <div css={ticketInfoWrapperStyle(40)}>
          <img
            src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/sameday-top.png"}
            css={canfetiImgStyle}
          />
          <div css={samedayLinkWrapperStyle}>
            <a
              href="https://www.diskgarage.com/ticket/detail/no093626"
              css={linkTxtStyle}
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.diskgarage.com/ticket/detail/no093626
            </a>
          </div>
          <img
            src={
              process.env.REACT_APP_ASSET_BASE_PATH + "/img/sameday-center.png"
            }
            css={canfetiImgStyle}
          />
          <div css={samedayLinkWrapperStyle}>
            <a
              href="https://www.diskgarage.com/ticket/detail/no093625"
              css={linkTxtStyle}
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.diskgarage.com/ticket/detail/no093625
            </a>
          </div>
          <img
            src={
              process.env.REACT_APP_ASSET_BASE_PATH + "/img/sameday-bottom.png"
            }
            css={canfetiImgStyle}
          />
          <div css={samedayLinkWrapperStyle}>
            <a
              href="https://www.diskgarage.com/ticket/detail/no093621"
              css={linkTxtStyle}
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.diskgarage.com/ticket/detail/no093621
            </a>
          </div>
        </div>
        <div css={ticketInfoWrapperStyle(10)}>
          <img
            src={
              process.env.REACT_APP_ASSET_BASE_PATH +
              "/img/on-the-site-sale.png"
            }
            css={canfetiImgStyle}
          />
        </div>
      </div>
    </div>
  );
};

const primaryColor = "#DD6B74";

const mainStyle = css`
  width: 100%;
  padding-bottom: 40px;
`;

const staffContentsWrapperStyle = css`
  display: flex;
  justify-content: center;
`;

const titleWrapp = css`
  width: 100%;
  max-width: 500px;
  padding: 30px 20px 0px;
`;

const upperTitleWrapperStyle = css`
  display: flex;
  align-items: center;
`;

const borderStyle = css`
  height: 1px;
  background-color: ${primaryColor};
  flex-grow: 1;
`;

const titleStyle = css`
  margin: 0 10px;
  font-size: 12pt;
  font-weight: 500;
`;

const ticketInfoWrapperStyle = (paddingTop?: number) => css`
  padding-top: ${paddingTop || 30}px;
`;

const contactStyle = css`
  padding-top: 5px;
  font-size: 10px;
  font-weight: bold;
`;

const ticketInfoImgStyle = css`
  width: 80%;
  max-width: 350px;
`;

const lawsonTicketInfoImgStyle = css`
  margin-top; 30px;
  width: 50%;
  max-width: 220px;
`;

const ticketLinkStyle = css`
  padding-top: 30px;
  display: flex;
  justify-content: center;
`;

const canfetiImgStyle = css`
  width: 85%;
  max-width: 370px;
`;

const linkTxtStyle = css`
  color: ${primaryColor};
  font-weight: bold;
`;

const samedayLinkWrapperStyle = css`
  padding-bottom: 30px;
  font-size: 14px;
`;

export default Tickets;
